

import { useAsObservableSource } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import { observer } from 'src/utils/mobx-react';
import { GradeState } from './Grade.state';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';

interface GradePropsTypes {
    eventId: EventId
}

export const Grade = observer('Grade', (propsIn: GradePropsTypes) => {
    const props = useAsObservableSource(propsIn);
    const { sdkStaff } = useAppStateContext();
    const [gradeState] = useState(() => new GradeState(() => props.eventId, sdkStaff));

    const {
        isLoadingEventUpdate,
        gradesForView,
        gradesPrematch, onChangeGradesPrematch,
        gradesInPlay, onChangeGradesInPlay,
        gradesShow, onChangeGradesShow,
    } = gradeState;

    return (
        <section className='event-details-box'>
            <h4>Grade <span style={{ fontSize: '10px' }}>{isLoadingEventUpdate ? 'Making changes, wait...' : null}</span></h4>
            <div>
                <div className='element hasLabel'>
                    <div className={'select-wrapper'}>
                        {gradesPrematch !== null ? (
                            <select
                                value={gradesPrematch?.id ?? undefined}
                                onChange={onChangeGradesPrematch}
                            >
                                {
                                    gradesForView.map(grade => (<option key={grade.id} value={grade.id ?? -1}> {grade.name} </option>))
                                }
                            </select>
                        ) : null}
                        <label>Prematch grade</label>
                    </div>
                </div>
                <div className='element hasLabel'>
                    <div className={'select-wrapper'}>
                        {gradesShow !== null ? (
                            <select
                                value={gradesShow?.id ?? undefined}
                                onChange={onChangeGradesShow}
                            >
                                {
                                    gradesForView.map(grade => (<option key={grade.id} value={grade.id ?? -1}> {grade.name} </option>))
                                }
                            </select>
                        ) : null}
                        <label>Show grade</label>
                    </div>
                </div>
                <div className='element hasLabel'>
                    <div className={'select-wrapper'}>
                        {gradesInPlay !== null ? (
                            <select
                                value={gradesInPlay?.id ?? undefined}
                                onChange={onChangeGradesInPlay}
                            >
                                {
                                    gradesForView.map(grade => (<option key={grade.id} value={grade.id ?? -1}> {grade.name} </option>))
                                }
                            </select>
                        ) : null}
                        <label>In-play grade</label>
                    </div>
                </div>
            </div>
        </section>
    );
});
